"use client";

import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import LoginForm from "./LoginForm";
import { Suspense } from "react";
import Link from "next/link";

const UI = () => {
  const query = useSearchParams();
  const redirect = query.get("redirect");

  return (
    <div
      className="min-h-dvh flex items-center justify-center px-4 py-16"
      style={{
        backgroundImage:
          "linear-gradient(to right, rgba(15, 23, 42, 0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(15, 23, 42, 0.06) 1px, transparent 1px)",
        backgroundSize: "48px 48px",
        backgroundColor: "#fff",
      }}
    >
      <div className="w-full max-w-md stack gap-0">
        <div className="border border-black bg-white">
          <div className="border-b border-black/10 px-8 py-6 stack gap-2">
            <p className="text-[1rem] uppercase tracking-[0.25em] text-gray-500">
              Thinknado
            </p>
            <h1 className="text-2xl font-black uppercase leading-tight">
              Sign In
            </h1>
          </div>

          <div className="px-8 py-6 stack gap-6">
            <button
              type="button"
              onClick={async () => {
                await signIn("google", {
                  callbackUrl: redirect || `/app/history`,
                });
              }}
              className="w-full border border-black/30 bg-white px-4 py-3 text-sm font-semibold hover:border-black transition flex items-center justify-center gap-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 18 18"
                aria-hidden="true"
              >
                <path
                  fill="#4285f4"
                  fillRule="evenodd"
                  d="M17.64 9.2q-.002-.956-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
                />
                <path
                  fill="#34a853"
                  fillRule="evenodd"
                  d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.26c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18"
                />
                <path
                  fill="#fbbc05"
                  fillRule="evenodd"
                  d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.96H.957C.347 6.175 0 7.55 0 9.002c0 1.452.348 2.827.957 4.042z"
                />
                <path
                  fill="#ea4335"
                  fillRule="evenodd"
                  d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71"
                />
              </svg>
              Continue with Google
            </button>

            <div className="flex items-center gap-4">
              <div className="flex-1 border-t border-black/10" />
              <span className="text-[1rem] uppercase tracking-[0.2em] text-gray-400">
                or
              </span>
              <div className="flex-1 border-t border-black/10" />
            </div>

            <LoginForm redirectTo={redirect} />
          </div>
        </div>

        <div className="border border-t-0 border-black/20 bg-gray-50 px-8 py-4 flex items-center justify-center">
          <Link
            href="/"
            className="text-[1rem] uppercase tracking-[0.2em] text-gray-500 hover:text-black transition-colors"
          >
            ← Back to Thinknado
          </Link>
        </div>
      </div>
    </div>
  );
};

export default function Login() {
  return (
    <Suspense>
      <UI />
    </Suspense>
  );
}
